import { filterByDateRange } from './dateRange';
import { filterOrdersByDateRange } from './orderUtils';
import {
  generateOrdersWeeklyPDF,
  generateOrdersMonthlyPDF,
  generateDispatchedWeeklyPDF,
  generateDispatchedMonthlyPDF,
  generateReturnedPDF,
  generateOwnerPeriodPDF,
} from './pdfReports';
import {
  exportOrdersReportExcel,
  exportDispatchedReportExcel,
  exportReturnedReportExcel,
  exportOwnerWithdrawalsReportExcel,
} from './exportUtils';

const periodLabel = (from, to) => `${from} to ${to}`;

export const runOrdersReportExport = ({
  format,
  periodType,
  from,
  to,
  orders,
  category,
  includeRevenueStats = false,
}) => {
  const exportOrders = filterOrdersByDateRange(orders, from, to);
  if (!exportOrders.length) return 'No orders found in this date range.';

  const label = periodLabel(from, to);

  if (format === 'pdf') {
    if (periodType === 'weekly') {
      generateOrdersWeeklyPDF(exportOrders, label, category);
    } else {
      const revenue = exportOrders.reduce((s, o) => s + o.orderTotal, 0);
      const productsSold = exportOrders.reduce(
        (s, o) => s + o.items.reduce((si, i) => si + i.quantity, 0),
        0
      );
      generateOrdersMonthlyPDF(exportOrders, label, category, {
        revenue: includeRevenueStats ? revenue : undefined,
        productsSold: includeRevenueStats ? productsSold : undefined,
      });
    }
  } else {
    exportOrdersReportExcel(exportOrders, { periodType, from, to, category });
  }

  return null;
};

export const runDispatchedReportExport = ({ format, periodType, from, to, orders }) => {
  const exportOrders = filterOrdersByDateRange(orders, from, to);
  if (!exportOrders.length) return 'No dispatched orders found in this date range.';

  const label = periodLabel(from, to);

  if (format === 'pdf') {
    if (periodType === 'weekly') {
      generateDispatchedWeeklyPDF(exportOrders, label);
    } else {
      const revenue = exportOrders.reduce((s, o) => s + o.orderTotal, 0);
      const productsSold = exportOrders.reduce(
        (s, o) => s + o.items.reduce((si, i) => si + i.quantity, 0),
        0
      );
      generateDispatchedMonthlyPDF(exportOrders, label, { revenue, productsSold });
    }
  } else {
    exportDispatchedReportExcel(exportOrders, { periodType, from, to });
  }

  return null;
};

export const runReturnedReportExport = ({ format, periodType, from, to, orders, returns }) => {
  const exportOrders = filterOrdersByDateRange(orders, from, to);
  if (!exportOrders.length) return 'No returned orders found in this date range.';

  const label = periodLabel(from, to);

  if (format === 'pdf') {
    generateReturnedPDF(exportOrders, returns, label, periodType);
  } else {
    exportReturnedReportExcel(exportOrders, returns, { periodType, from, to });
  }

  return null;
};

export const runOwnerReportExport = ({ format, periodType, from, to, finance }) => {
  const withdrawals = filterByDateRange(finance.withdrawals, from, to);
  if (!withdrawals.length) return 'No withdrawals found in this date range.';

  const label = periodLabel(from, to);
  const scopedFinance = { ...finance, withdrawals };

  if (format === 'pdf') {
    generateOwnerPeriodPDF(scopedFinance, label, periodType);
  } else {
    exportOwnerWithdrawalsReportExcel(scopedFinance, { periodType, from, to });
  }

  return null;
};
